<template>
  <div class="page-content">
    <div class="password-card">
      <div class="card-header">
        <h3>
          <i class="el-icon-lock"></i>
          修改管理员密码
        </h3>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>当前密码</label>
          <div class="input-wrapper">
            <i class="el-icon-view"></i>
            <input
              v-model="form.oldPassword"
              type="password"
              class="form-input"
              placeholder="请输入当前密码"
            />
          </div>
        </div>
        <div class="form-group">
          <label>新密码</label>
          <div class="input-wrapper">
            <i class="el-icon-lock"></i>
            <input
              v-model="form.newPassword"
              type="password"
              class="form-input"
              placeholder="请输入新密码（至少6位）"
            />
          </div>
        </div>
        <div class="form-group">
          <label>确认新密码</label>
          <div class="input-wrapper">
            <i class="el-icon-lock"></i>
            <input
              v-model="form.confirmPassword"
              type="password"
              class="form-input"
              placeholder="请再次输入新密码"
            />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary" @click="handleSubmit">
          <i class="el-icon-check"></i>
          确认修改
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordChange',
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.form.oldPassword) {
        this.$message.error('请输入当前密码')
        return
      }
      if (!this.form.newPassword) {
        this.$message.error('请输入新密码')
        return
      }
      if (this.form.newPassword.length < 6) {
        this.$message.error('新密码至少6位')
        return
      }
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.$message.error('两次密码输入不一致')
        return
      }
      try {
        await this.$http({
          url: '/admin/change-password',
          method: 'post',
          data: {
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword
          }
        })
        this.$message.success('密码修改成功')
        this.form = {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        }
      } catch (error) {
        this.$message.error('密码修改失败')
      }
    }
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css');

.page-content {
  max-width: 500px;
}

.password-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  padding: 16px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-header i {
  color: #07c160;
}

.card-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.input-wrapper {
  position: relative;
}

.input-wrapper i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 16px;
}

.form-input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  border-color: #07c160;
  box-shadow: 0 0 0 3px rgba(7, 193, 96, 0.1);
}

.form-input::placeholder {
  color: #94a3b8;
}

.card-footer {
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  width: 100%;
}

.btn i {
  font-size: 16px;
}

.btn-primary {
  background: #07c160;
  color: #fff;
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.25);
}

.btn-primary:hover {
  background: #06ae56;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.35);
}
</style>